/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { isEmpty } from '../../../../../utils/object';


const getFullAddressString = (addressFields) => {
    let fullAddress = addressFields.addressLineOne;
    if (addressFields.addressLineTwo && addressFields.addressLineTwo.trim()) {
        fullAddress += ` ${addressFields.addressLineTwo.trim()}, `;
    } else {
        fullAddress += ', ';
    }
    if (addressFields.city && addressFields.city.trim()) {
        fullAddress += `${addressFields.city.trim()} `;
    }
    if (addressFields.state) {
        fullAddress += `${addressFields.state} `;
    }
    if (addressFields.zip) {
        fullAddress += addressFields.zip;
    }
    return fullAddress;
};

export const hasSuggestedAddress = ({ formatedSelectedAddress, methods, searchResults }) => {
    let isSuggested = true;
    const addressFields = {
        addressLineOne: methods?.getValues('addressLineOne'),
        addressLineTwo: methods?.getValues('addressLineTwo'),
        city: methods?.getValues('city'),
        state: methods?.getValues('state'),
        zip: methods?.getValues('zip'),
        country: methods?.getValues('country'),
    }
    if (!isEmpty(formatedSelectedAddress)) {
        // Compare every input field with the formatedSelectedAddress
        Object.keys(formatedSelectedAddress).forEach((item) => {
            if (formatedSelectedAddress[item] !== addressFields[item]) {
                isSuggested = false;
            }
        });
    } else {
        isSuggested = false;
    }
    const fullAddress = getFullAddressString(addressFields);
    const suggestedList = !isEmpty(searchResults);
    if (suggestedList) {
        // Compare full address with the suggestedList
        searchResults.forEach((item) => {
            const adjustString = (str) => str.toUpperCase().replace(/\s/g, ''); // to get rid of space and letters mismatch
            if (adjustString(item.suggestion) === adjustString(fullAddress)) {
                isSuggested = true;
            }
        });
    }
    return isSuggested;
};